// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__RLwR8","bigColWidth":"Table_bigColWidth__PVZXU","biggerColWidth":"Table_biggerColWidth__16tt3","row":"Table_row__1cMBv","col":"Table_col__30070"};